
import { IAccessibleViewImplentation } from 'vs/platform/accessibility/browser/accessibleViewRegistry';

export class InlineCompletionsAccessibleView implements IAccessibleViewImplentation {
}

